var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.header.type === _vm.HEADER_TYPE.SEARCH)?_c('LayoutHeaderSearch'):_vm._e(),(_vm.header.type === _vm.HEADER_TYPE.CUSTOM)?_c('LayoutHeaderCustom'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }